// Shared Tailwind class constants for ResortStrengths + Category.

export const wrapperClass = [
  'relative flex flex-col items-center justify-center',
  'p-[25px] rounded-t-lg',
  'max-md:my-0 max-md:mx-2.5 max-md:mb-5',
].join(' ');

export const bgClass = 'absolute top-0 w-full h-full bg-white opacity-60 z-0';

export const imageClass = [
  'absolute top-[25px] left-[25px] w-full h-full max-w-[63px] max-h-[63px]',
  'max-md:static max-md:z-[1]',
].join(' ');

export const categoriesBoxClass = [
  'relative z-[1] flex flex-col items-center my-9',
  'max-md:my-2',
].join(' ');

export const categoryClass = [
  'text-center text-primary mb-2',
  'text-[clamp(0.75rem,1.25vw,1.25rem)] leading-[1.753125rem]',
  'max-md:text-sm max-md:leading-[1.275rem]',
].join(' ');

export const positionClass = 'font-bold pr-[0.371875rem]';

export const linkAllReviewsClass = [
  'mt-8 px-[21px] py-[15px]',
  'bg-[#11ABD8] rounded-md',
  'font-bold text-sm leading-[1.0625rem] text-white',
  'max-md:mt-0 max-md:px-[25px] max-md:py-2 max-md:text-xs',
].join(' ');

export const linkClass = [
  'text-white font-medium ml-2',
  'max-sm:ml-1.5',
].join(' ');
